import * as React from "react";
import { createRoot } from 'react-dom/client';
import Main from "./components/Main";
import { createTheme } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    palette: {
      primary: {
        light: '#E53037',
        main: '#138B2C',//"#138B2C", //PANTONE 032 C
        dark: '#0D5487',
        contrastText: '#fff',
      },
      secondary: {
        light: '#FF0000', 
        main: '#138B2C', //'#138B2C', //PANTONE 012C
        dark: '#DDD700',
        contrastText: '#000',
      }
    }
  });


  const container = document.getElementById('main');

const root = createRoot(container);
root.render(<ThemeProvider theme={theme}>
  <Main/>
</ThemeProvider>);
